var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudFogMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.819,46.758L69.819,46.758c0.617,0.88,1.102,1.854,1.469,2.884h0.019l0,0H66.92 l0,0l0,0c-1.384-2.389-3.962-3.999-6.921-3.999c-1.6,0-3.082,0.48-4.333,1.29c-1.231-5.316-5.974-9.29-11.665-9.29 c-6.626,0-11.998,5.372-11.998,11.999l0,0h-4l0,0c0-8.835,7.163-15.998,15.998-15.998c2.003,0,3.914,0.376,5.68,1.048l0,0 c1.635-4.683,6.079-8.047,11.318-8.047c0.756,0,1.492,0.078,2.208,0.211c-0.132,0.576-0.208,1.173-0.208,1.789 c0,4.418,3.582,7.998,7.999,7.998c0.616,0,1.212-0.076,1.788-0.207c0.134,0.717,0.212,1.452,0.212,2.207 C72.998,41.777,71.786,44.621,69.819,46.758z M59.212,30.852c-2.9,0.663-5.175,2.91-5.924,5.774l0,0 c1.916,1.372,3.521,3.153,4.678,5.222c0.664-0.114,1.338-0.205,2.033-0.205c2.619,0,5.033,0.848,7.006,2.271l0,0 c0.858-0.98,1.485-2.169,1.785-3.482C63.937,39.527,60.115,35.706,59.212,30.852z M30.003,53.641h39.996 c1.104,0,1.999,0.896,1.999,2s-0.896,2-1.999,2H30.003c-1.104,0-2-0.896-2-2S28.899,53.641,30.003,53.641z M30.003,61.641h39.996 c1.104,0,1.999,0.895,1.999,1.999s-0.896,2-1.999,2H30.003c-1.104,0-2-0.896-2-2S28.899,61.641,30.003,61.641z M30.003,69.639 h39.996c1.104,0,1.999,0.896,1.999,2s-0.896,2-1.999,2H30.003c-1.104,0-2-0.896-2-2S28.899,69.639,30.003,69.639z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFogMoon);
export default __webpack_public_path__ + "static/media/Cloud-Fog-Moon.e80c1355ffd460af4e30c476aa7e5db2.svg";
export { ForwardRef as ReactComponent };